import { useInfiniteQuery } from '@tanstack/react-query';

import { toChatListItemViewModel } from '@/entities/chat';
import { delay } from '@/helpers/helpers';
import { QueryKey } from '@/types/query';
import { useMemo } from 'react';
import { chatOverviewClient } from './client';

export const useChatOverviewInfiniteQuery = () => {
  const query = useInfiniteQuery({
    queryKey: [QueryKey.useChatOverviewInfiniteQuery],
    queryFn: async () => {
      await delay(1500);
      const { data: response } = await chatOverviewClient.getChatList();

      return response;
    },
  });

  const data = useMemo(() => {
    return query.data?.pages.flatMap((page) => page.map(toChatListItemViewModel)) || [];
  }, [query.data?.pages]);

  return { ...query, data };
};
